/**
 * Size keys, as per Tailwind CSS
 */
export enum SIZE {
    XS = "xs",
    SM = "sm",
    BASE = "base",
    LG = "lg",
    XL = "xl",
}

interface IconSize {
    value: number; // size in pixels based on our custom sizing base: 1rem = 12px
    className: string; // class name for the icon
}

/**
 * Icon sizes using Tailwind CSS classes
 * Values are based on what the tailwind classes would result in,
 * assuming the base size is 12px (1rem)
 */
export const ICON_SIZE: Record<SIZE, IconSize> = {
    [SIZE.XS]: {
        value: 17,
        className: "size-5",
    },
    [SIZE.SM]: {
        value: 20,
        className: "size-6",
    },
    [SIZE.BASE]: {
        value: 23,
        className: "size-7",
    },
    [SIZE.LG]: {
        value: 26,
        className: "size-8",
    },
    [SIZE.XL]: {
        value: 29,
        className: "size-9",
    },
};
